import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { firstAnalysesActions } from 'features/firstAnalyses';

const useFirstAnalyses = () => {
  const dispatch = useDispatch();
  const getFirstAnalyses = useCallback(({ offset }) => dispatch(firstAnalysesActions.getFirstAnalyses({ offset })), [dispatch]);
  const getFirstAnalysis = useCallback(({ id, cable }) => dispatch(firstAnalysesActions.getFirstAnalysis({ id, cable })), [dispatch]);
  const clearLocalFirstAnalyses = useCallback(() => dispatch(firstAnalysesActions.clearLocalFirstAnalyses()), [dispatch]);
  const clearLocalActiveFirstAnalysis = useCallback(() => dispatch(firstAnalysesActions.clearLocalActiveFirstAnalysis()), [dispatch]);

  return {
    getFirstAnalyses,
    getFirstAnalysis,
    clearLocalFirstAnalyses,
    clearLocalActiveFirstAnalysis
  };
};

export default useFirstAnalyses;